import * as React from 'react';
import { isMobile } from 'react-device-detect';
import { noop } from 'underscore';

import SaveToDriveButton from 'components/SaveToDriveButton';
import SaveToDropboxButton from 'components/SaveToDropboxButton';
import { block } from '../../utils';
import useOnDownloadPageAction from '../useOnDownloadPageAction';

export interface CloudUploadSectionProps {
  onUploadSuccess?: (provider: string) => void;
  videoFileName?: string;
  videoUrl: string;
}

const CloudUploadSection: React.SFC<CloudUploadSectionProps> = ({
  onUploadSuccess,
  videoFileName,
  videoUrl,
}) => {
  const { onDownloadPageAction } = useOnDownloadPageAction();

  return (
    <div className={block('cloud-section')}>
      <div className={block('cloud-row')}>
        <div className={block('cloud-label')}>
          Upload to cloud storage accounts:
        </div>
        <div className={block('cloud-buttons')}>
          {!isMobile && videoUrl && videoFileName && (
            <SaveToDriveButton sourceFile={videoUrl} fileName={videoFileName} />
          )}
          {videoUrl && videoFileName && (
            <SaveToDropboxButton
              className={block('dropbox-button')}
              onClick={() => onDownloadPageAction('cloudUpload', 'dropbox')}
              onUploadSuccess={() => onUploadSuccess?.('dropbox')}
              sourceFile={videoUrl}
              fileName={videoFileName}
            />
          )}
        </div>
      </div>
    </div>
  );
};

CloudUploadSection.defaultProps = {
  onUploadSuccess: noop,
};

export default CloudUploadSection;
